import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

const SupportText = styled.div<React.CSSProperties>`
  color: ${Colors['light']};
  font-family: ${Fonts['regular']};
  font-size: ${32 * Screen.widthRatio}px;
  margin-bottom: ${8 * Screen.widthRatio}px;
  max-width: ${1400 * Screen.widthRatio}px;
`;

export default SupportText;
